import Helper from './Helper';

class ToTop {
  constructor(config) {
    const { minScrollVisible } = config;

    this.minScrollVisible = minScrollVisible;
    this.isOnTop = document.body.getBoundingClientRect().top > this.minScrollVisible;
    this.toTop = document.querySelector('.js-to-top-toggler');
    this.bClassAdded = false;

    if (window.pageYOffset > this.minScrollVisible) {
      document.querySelector('.content').classList.add('show-to-top');
      this.bClassAdded = true;
    }

    if (this.toTop)
      this.bindEvents();
  }

  bindEvents() {
    this.toTop.addEventListener('click', (e) => {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    });
    this.handleClasses();
  }

  handleClasses() {
    window.addEventListener('scroll', (e) => {
      if (window.pageYOffset > this.minScrollVisible) {
        document.querySelector('.content').classList.add('show-to-top');
        this.bClassAdded = true;
      } else {
        document.querySelector('.content').classList.remove('show-to-top');
        this.bClassAdded = false;
      };
    });
  }
}

export default ToTop;